export function getDatesNoLongerAvailableConfig() {
  return {
    type: 'info',
    title: 'Sorry! These dates are no longer available',
    text: 'This venue isn\'t available for the dates you\'ve picked. Please select different dates or send enquiries to other recommended venues.',
    button: 'Got it',
  };
}
export function getIsLimitExceededConfig(rfpsLimit) {
  return {
    type: 'warning',
    title: 'Active enquiries limit reached',
    text: `You've reached the limit of ${rfpsLimit} active enquiries. To send new ones, please decline any existing enquiries that don't fit your event needs`,
    button: 'Got it',
  };
}
export function getIsEmailRecognizedConfig() {
  return {
    type: 'success',
    title: 'Welcome back, your enquiry was sent!',
    text: 'We\'ve noticed there\'s an account linked to this email. Please log in to view and manage all your enquiries.',
    button: 'Got it',
  };
}
